<template>
  <div class="app-container">
    <el-card style="margin-bottom: 10px">
      <el-form :inline="true" @keyup.enter.native="generate">
        <el-form-item label="生成类型">
          <el-radio-group v-model="genType" @change="onTypeChange">
            <el-radio-button label="day">按日</el-radio-button>
            <el-radio-button label="week">按周</el-radio-button>
            <el-radio-button label="month">按月</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="选择日期">
          <el-date-picker
              v-model="pickDate"
              :type="genType === 'day' ? 'date' : (genType === 'week' ? 'date' : 'month')"
              :value-format="genType === 'month' ? 'yyyy-MM' : 'yyyy-MM-dd'"
              :placeholder="genType === 'month' ? '选择月份' : (genType === 'week' ? '选择一周内任意日期' : '选择日期')"
              style="width: 200px"/>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-refresh" :loading="generating" @click="generate">生成排班</el-button>
          <el-button
              type="success"
              icon="el-icon-check"
              :loading="saving"
              :disabled="!rotaList.length"
              @click="save">
            保存
          </el-button>
          <el-button icon="el-icon-back" @click="goBack">返回</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <el-card>
      <div slot="header" class="clearfix">
        <span>排班明细（共 {{rotaList.length}} 条）</span>
        <el-button type="success" size="mini" icon="el-icon-plus" style="margin-left: 10px" @click="addRow">新增</el-button>
        <span v-if="rotaList.length" style="color: #909399; font-size: 12px; margin-left: 10px">
          日历当天无班次的员工已保留，可手动补充班次/时间
        </span>
      </div>
      <el-table
          :data="rotaList"
          border
          size="small"
          row-key="rowKey"
          :row-class-name="dateRowClass"
          max-height="600"
          style="width: 100%">
        <el-table-column type="index" width="46" align="center" fixed="left"/>
        <el-table-column label="班组" prop="teamName" width="150" fixed="left">
          <template slot-scope="scope">
            <el-input v-model="scope.row.teamName" size="mini" readonly>
              <el-button slot="append" icon="el-icon-search" @click="openTeamSelect(scope.row)"/>
            </el-input>
          </template>
        </el-table-column>
        <el-table-column label="员工姓名" prop="empName" width="150">
          <template slot-scope="scope">
            <el-input v-model="scope.row.empName" size="mini" readonly>
              <el-button slot="append" icon="el-icon-search" @click="openEmpSelect(scope.row)"/>
            </el-input>
          </template>
        </el-table-column>
        <el-table-column label="周几" width="56" align="center">
          <template slot-scope="scope">
            <span>{{weekdayName(scope.row.rotaDate)}}</span>
          </template>
        </el-table-column>
        <el-table-column label="排班日期" prop="rotaDate" width="150">
          <template slot-scope="scope">
            <el-date-picker
                v-model="scope.row.rotaDate"
                type="date"
                value-format="yyyy-MM-dd"
                size="mini"
                style="width: 100%"
                @change="onDateChange(scope.row)"/>
          </template>
        </el-table-column>
        <el-table-column label="岗位类型" prop="postType" width="120">
          <template slot-scope="scope">
            <el-select v-model="scope.row.postType" size="mini" style="width: 100%">
              <el-option label="普通操作工" :value="1"/>
              <el-option label="班组长" :value="2"/>
              <el-option label="顶岗人员" :value="3"/>
              <el-option label="质检员" :value="4"/>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="班次" prop="shiftName" min-width="120">
          <template slot-scope="scope">
            <el-select
                v-model="scope.row.calShiftRefId"
                size="mini"
                style="width: 100%"
                placeholder="无班次"
                clearable
                @change="val => onShiftChange(scope.row, val)">
              <el-option
                  v-for="s in getEffectiveShifts(scope.row.calendarId, scope.row.rotaDate)"
                  :key="s.refId"
                  :label="s.shiftName"
                  :value="s.refId"/>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="上班时间" prop="workStart" min-width="90">
          <template slot-scope="scope">
            <el-time-picker
                v-model="scope.row.workStart"
                value-format="HH:mm:ss"
                format="HH:mm"
                class="time-picker-no-icon"
                style="width: 100%"
                @change="recalcStandardWorkHour(scope.row)"/>
          </template>
        </el-table-column>
        <el-table-column label="下班时间" prop="workEnd" min-width="90">
          <template slot-scope="scope">
            <el-time-picker
                v-model="scope.row.workEnd"
                value-format="HH:mm:ss"
                format="HH:mm"
                class="time-picker-no-icon"
                style="width: 100%"
                @change="recalcStandardWorkHour(scope.row)"/>
          </template>
        </el-table-column>
        <el-table-column label="休息时间" width="170">
          <template slot-scope="scope">
            <span class="rest-time-wrap">
              <el-time-picker
                  v-model="scope.row.restStart"
                  value-format="HH:mm:ss"
                  format="HH:mm"
                  class="time-picker-no-icon"
                  style="width: 80px"
                  @change="recalcStandardWorkHour(scope.row)"/>
              <span class="rest-time-sep">~</span>
              <el-time-picker
                  v-model="scope.row.restEnd"
                  value-format="HH:mm:ss"
                  format="HH:mm"
                  class="time-picker-no-icon"
                  style="width: 80px"
                  @change="recalcStandardWorkHour(scope.row)"/>
            </span>
          </template>
        </el-table-column>
        <el-table-column label="标准工时" prop="standardWorkHour" min-width="80">
          <template slot-scope="scope">
            <span>{{formatStandardWorkHour(scope.row)}}</span>
          </template>
        </el-table-column>
        <el-table-column label="是否加班" prop="canOvertime" min-width="90">
          <template slot-scope="scope">
            <el-select v-model="scope.row.canOvertime" size="mini" style="width: 100%">
              <el-option label="否" :value="0"/>
              <el-option label="是" :value="1"/>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="最大加班" prop="overtimeMaxHour" min-width="80">
          <template slot-scope="scope">
            <el-input-number
                v-model="scope.row.overtimeMaxHour"
                :min="0"
                :precision="2"
                :controls="false"
                size="mini"
                style="width: 100%"/>
          </template>
        </el-table-column>
        <el-table-column label="是否借调" prop="isBorrow" min-width="100">
          <template slot-scope="scope">
            <el-select v-model="scope.row.isBorrow" size="mini" style="width: 100%">
              <el-option label="本班组人员" :value="0"/>
              <el-option label="内部借调" :value="1"/>
              <el-option label="外协支援" :value="3"/>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="备注" prop="remark" min-width="100">
          <template slot-scope="scope">
            <el-input v-model="scope.row.remark" size="mini" placeholder="备注"/>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="60" fixed="right" align="center">
          <template slot-scope="scope">
            <el-button type="text" style="color: #f56c6c" @click="removeRow(scope.$index)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <!-- 班组选择器 -->
    <team-select ref="teamSelect" @select="selectTeam"/>

    <!-- 员工选择器 -->
    <employee-select ref="empSelect" @select="selectEmp"/>
  </div>
</template>

<script>
  import TeamSelect from "./TeamSelect";
  import EmployeeSelect from "@/views/information/Employee/EmployeeSelect";

  const WEEKDAY_NAMES = ["周日", "周一", "周二", "周三", "周四", "周五", "周六"];

  export default {
    name: "TeamShiftRotaGenerate",
    components: { TeamSelect, EmployeeSelect },
    data() {
      return {
        genType: "day",
        pickDate: "",
        generating: false,
        saving: false,
        rotaList: [],
        // 缓存：calendarId -> 班次选项列表（供每行班次下拉使用）
        shiftMap: {},
        // 日期→颜色索引（按 pickDate 范围内出现顺序）
        dateColorIndex: {},
        dateColorCounter: 0,
        // 当前正在编辑的行（选择器使用）
        currentRow: null,
      };
    },
    mounted() {
      // 默认日期为当天
      this.pickDate = this.todayStr();
    },
    methods: {
      // 当天日期，按 genType 返回对应格式（month=yyyy-MM，其余=yyyy-MM-dd）
      todayStr() {
        const now = new Date();
        const pad = (n) => String(n).padStart(2, "0");
        const ymd = `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`;
        if (this.genType === "month") {
          return ymd.substring(0, 7);
        }
        return ymd;
      },
      onTypeChange() {
        // 切换类型时，默认日期重置为当天（对应格式）
        this.pickDate = this.todayStr();
        this.rotaList = [];
        this.shiftMap = {};
        this.dateColorIndex = {};
        this.dateColorCounter = 0;
      },
      generate() {
        if (!this.pickDate) {
          this.$message.warning("请先选择日期");
          return;
        }
        this.generating = true;
        this.dateColorIndex = {};
        this.dateColorCounter = 0;
        const params = {
          genType: this.genType,
          pickDate: this.pickDate,
        };
        this.$http.post("basic", "mES_TeamShiftRotas/generate", params)
          .then((resp) => {
            if (resp.success) {
              const data = resp.data || {};
              this.rotaList = (data.rotaList || []).map((r, i) => {
                // 按 rotaDate 分配颜色索引
                if (this.dateColorIndex[r.rotaDate] === undefined) {
                  this.dateColorIndex[r.rotaDate] = this.dateColorCounter % 2;
                  this.dateColorCounter += 1;
                }
                return {
                  ...r,
                  rowKey: (r.teamId || "") + "_" + (r.empId || "") + "_" + (r.rotaDate || "") + "_" + i,
                };
              });
              // 缓存班次选项：按 calendarId 分组
              const shiftMap = {};
              (data.shiftList || []).forEach((s) => {
                const cid = s.calendarId;
                if (!shiftMap[cid]) shiftMap[cid] = [];
                shiftMap[cid].push(s);
              });
              this.shiftMap = shiftMap;
              if (!this.rotaList.length) {
                this.$message.warning(data.message || "没有可生成的排班数据");
              }
            }
          })
          .finally(() => {
            this.generating = false;
          });
      },
      // 打开班组选择器
      openTeamSelect(row) {
        this.currentRow = row;
        this.$refs.teamSelect.open();
      },
      selectTeam(team) {
        const row = this.currentRow;
        if (!row) return;
        row.teamId = team.id;
        row.teamName = team.teamName;
        row.calendarId = team.defaultCalendarId;
        row.calendarName = team.defaultCalendarName;
        // 切换班组后清空班次
        row.calShiftRefId = null;
        row.shiftName = "";
      },
      // 打开员工选择器（选择全部员工，班组带出的员工仅作为默认值）
      openEmpSelect(row) {
        this.currentRow = row;
        this.$refs.empSelect.open();
      },
      selectEmp(emp) {
        const row = this.currentRow;
        if (!row) return;
        row.empId = emp.employeeID;
        row.empNo = emp.employeeNO;
        row.empName = emp.employeeName;
      },
      // 班次选项（按生效日期过滤，不去重）
      getEffectiveShifts(calendarId, date) {
        return (this.shiftMap[calendarId] || []).filter(
          (s) => this.isInEffect(s, date)
        );
      },
      isInEffect(shift, date) {
        if (!date) return true;
        if (shift.startDate && date < shift.startDate) return false;
        if (shift.endDate && date > shift.endDate) return false;
        return true;
      },
      onShiftChange(row, refId) {
        if (!refId) {
          row.shiftName = "";
          row.workStart = null;
          row.workEnd = null;
          row.restStart = null;
          row.restEnd = null;
          row.canOvertime = null;
          row.overtimeMaxHour = null;
          this.recalcStandardWorkHour(row);
          return;
        }
        const s = (this.shiftMap[row.calendarId] || []).find((x) => x.refId === refId);
        if (s) {
          row.shiftName = s.shiftName;
          row.workStart = s.workStart;
          row.workEnd = s.workEnd;
          row.restStart = s.restStart;
          row.restEnd = s.restEnd;
          row.canOvertime = s.canOvertime;
          row.overtimeMaxHour = s.overtimeMaxHour;
          // 标准工时由上班/下班/休息时间联动计算
          this.recalcStandardWorkHour(row);
        }
      },
      // 将 HH:mm:ss 字符串转为分钟数
      timeToMinutes(timeStr) {
        if (!timeStr) return null;
        const parts = String(timeStr).split(":");
        const h = Number(parts[0]);
        const m = Number(parts[1] || 0);
        if (isNaN(h) || isNaN(m)) return null;
        return h * 60 + m;
      },
      // 计算标准工时 = (下班-上班) - (休息结束-休息开始)，单位小时；夜班跨天自动加 24 小时
      calcStandardWorkHour(row) {
        const workStart = this.timeToMinutes(row.workStart);
        const workEnd = this.timeToMinutes(row.workEnd);
        const restStart = this.timeToMinutes(row.restStart);
        const restEnd = this.timeToMinutes(row.restEnd);
        if (workStart == null || workEnd == null) return null;
        let workMinutes = workEnd - workStart;
        if (workMinutes < 0) workMinutes += 24 * 60; // 跨天（夜班）
        let restMinutes = 0;
        if (restStart != null && restEnd != null) {
          restMinutes = restEnd - restStart;
          if (restMinutes < 0) restMinutes += 24 * 60;
        }
        const minutes = workMinutes - restMinutes;
        if (minutes < 0) return null;
        return Number((minutes / 60).toFixed(2));
      },
      // 重算并写回行的标准工时
      recalcStandardWorkHour(row) {
        const val = this.calcStandardWorkHour(row);
        this.$set(row, "standardWorkHour", val);
      },
      // 标准工时列只读展示
      formatStandardWorkHour(row) {
        const val = this.calcStandardWorkHour(row);
        return val == null ? "" : val;
      },
      onDateChange(row) {
        if (!row.rotaDate) return;
        // 新日期分配颜色索引
        if (this.dateColorIndex[row.rotaDate] === undefined) {
          this.dateColorIndex[row.rotaDate] = this.dateColorCounter % 2;
          this.dateColorCounter += 1;
        }
        // 若原班次在新日期不生效则清空
        if (row.calendarId && row.calShiftRefId) {
          const s = (this.shiftMap[row.calendarId] || []).find((x) => x.refId === row.calShiftRefId);
          if (s && !this.isInEffect(s, row.rotaDate)) {
            this.onShiftChange(row, null);
          }
        }
      },
      weekdayName(date) {
        if (!date) return "";
        // 兼容 "yyyy-MM-dd" 字符串
        const d = typeof date === "string" ? new Date(date) : date;
        if (isNaN(d.getTime())) return "";
        return WEEKDAY_NAMES[d.getDay()];
      },
      // 按 rotaDate 分配循环颜色 class
      dateRowClass({ row }) {
        if (!row.rotaDate) return "";
        const idx = this.dateColorIndex[row.rotaDate];
        return idx === undefined ? "" : `date-row-color-${idx}`;
      },
      removeRow(index) {
        this.rotaList.splice(index, 1);
      },
      // 手动新增一行空白排班明细
      addRow() {
        // 默认日期：按日/按周用 pickDate；按月取当月第一天
        let defaultDate = "";
        if (this.pickDate) {
          defaultDate = this.genType === "month" ? this.pickDate + "-01" : this.pickDate;
        }
        const row = {
          teamId: null,
          teamName: "",
          empId: null,
          empNo: "",
          empName: "",
          calendarId: null,
          calendarName: "",
          calShiftRefId: null,
          shiftName: "",
          rotaDate: defaultDate,
          postType: null,
          empType: null,
          workStart: null,
          workEnd: null,
          restStart: null,
          restEnd: null,
          standardWorkHour: null,
          canOvertime: null,
          overtimeMaxHour: null,
          isBorrow: 0,
          remark: "",
        };
        row.rowKey = (row.teamId || "") + "_" + (row.empId || "") + "_" + (row.rotaDate || "") + "_" + Date.now();
        this.rotaList.push(row);
      },
      save() {
        if (!this.rotaList.length) {
          this.$message.warning("没有可保存的排班数据");
          return;
        }
        this.saving = true;
        const payload = this.rotaList.map((r) => {
          const copy = { ...r };
          delete copy.rowKey;
          // 标准工时统一按上班/下班/休息时间联动计算
          copy.standardWorkHour = this.calcStandardWorkHour(r);
          return copy;
        });
        this.$http.post("basic", "mES_TeamShiftRotas/saveBatch", payload)
          .then((resp) => {
            if (resp.success) {
              this.$message.success("保存成功");
              this.rotaList = [];
              this.goBack();
            }
          })
          .finally(() => {
            this.saving = false;
          });
      },
      goBack() {
        this.$router.push({ name: "TeamShiftRotaList" });
      },
    },
  };
</script>

<style scoped>
  .el-table .cell {
    padding: 0 4px;
  }
  /* 隐藏时间控件的前缀时钟图标（el-time-picker 根元素 class 为 el-input，需用自定义 class 定位） */
  ::v-deep .time-picker-no-icon .el-input__prefix {
    display: none !important;
  }
  ::v-deep .time-picker-no-icon .el-input__inner {
    padding-left: 5px;
  }
  /* 休息时间：强制横向排列，不换行 */
  .rest-time-wrap {
    display: flex;
    align-items: center;
    white-space: nowrap;
  }
  .rest-time-sep {
    margin: 0 3px;
    flex-shrink: 0;
    line-height: 1;
  }
  /* 不同日期循环背景色（深浅循环：白 / 浅蓝 交替） */
  ::v-deep .date-row-color-0 td {
    background-color: #ffffff !important;
  }
  ::v-deep .date-row-color-1 td {
    background-color: #e6f0fa !important;
  }
</style>
